var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYouTubeN1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 30,
    viewBox: "0 0 41 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.689 0.209045H6.12396C4.7215 0.209045 3.37646 0.766181 2.38477 1.75787C1.39307 2.74957 0.835938 4.09454 0.835938 5.49701V23.989C0.835938 25.3914 1.39307 26.7365 2.38477 27.7282C3.37646 28.7199 4.7215 29.277 6.12396 29.277H35.6879C37.0904 29.277 38.4354 28.7199 39.4271 27.7282C40.4188 26.7365 40.976 25.3914 40.976 23.989V5.49701C40.976 4.09472 40.419 2.74978 39.4275 1.75812C38.436 0.766454 37.0913 0.209311 35.689 0.209045ZM25.6549 16.019L17.434 20.128C17.2165 20.2372 16.9747 20.289 16.7316 20.2784C16.4885 20.2677 16.2521 20.195 16.045 20.0672C15.838 19.9394 15.667 19.7607 15.5485 19.5482C15.43 19.3356 15.3678 19.0963 15.3679 18.853V10.639C15.3679 10.3957 15.4301 10.1564 15.5486 9.94391C15.6672 9.7314 15.8381 9.55273 16.0451 9.42487C16.2521 9.297 16.4884 9.22414 16.7314 9.21332C16.9745 9.2025 17.2164 9.25402 17.434 9.36298L25.6549 13.472C25.8915 13.5905 26.0906 13.7726 26.2296 13.9977C26.3687 14.2229 26.4423 14.4824 26.4423 14.747C26.4423 15.0117 26.3687 15.2711 26.2296 15.4963C26.0906 15.7215 25.8915 15.9035 25.6549 16.022V16.019Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeN1);
export default __webpack_public_path__ + "static/media/youTube-n-1.59a30fb77b2aca334096be6c4bf39930.svg";
export { ForwardRef as ReactComponent };